import { Button, Flex, Input, Text } from '@chakra-ui/react';
import SelectInput from 'components/inputs/SelectInput';
import PropTypes from 'prop-types';
import { forwardRef, useEffect, useState } from 'react';

import { SCENARIO_ADD_OPTION } from './slugifyScenarioName';

const ScenarioSelector = forwardRef(
  ({
    value,
    options,
    onLoad,
    onSave,
    onAdd,
    comments,
    onCommentsChange,
  }, ref) => {
    const [scenarioType, setScenarioType] = useState(null);

    useEffect(() => {
      setScenarioType(value);
    }, [value]);

    const handleScenarioChange = (nextValue) => {
      if (nextValue === SCENARIO_ADD_OPTION) {
        const name = window.prompt('Enter scenario name:');
        if (name?.trim() && onAdd) {
          onAdd(name.trim());
        }
        setScenarioType(value || null);
        return;
      }
      setScenarioType(nextValue);
    };

    const isSaveDisabled =
      !scenarioType ||
      scenarioType === 'default' ||
      scenarioType === SCENARIO_ADD_OPTION;

    return (
      <Flex gap={2} align={'center'}>
        <Text>Scenario:</Text>
        <SelectInput
          w={200}
          value={scenarioType}
          options={options}
          onChange={handleScenarioChange}
          placeholder={'-- Select Scenario --'}
        />
        <Text>Comments:</Text>
        <Input
          w={200}
          value={comments}
          onChange={(e) => onCommentsChange(e.target.value)}
        />
        <Button
          w={100}
          variant={'outline'}
          onClick={() => onLoad(scenarioType)}
          isDisabled={!scenarioType || scenarioType === SCENARIO_ADD_OPTION}
        >
          Load
        </Button>
        <Button
          w={100}
          variant={'outline'}
          onClick={() => onSave(scenarioType)}
          isDisabled={isSaveDisabled}
        >
          Save
        </Button>
      </Flex>
    );
  }
);

ScenarioSelector.propTypes = {
  value: PropTypes.string,
  options: PropTypes.array,
  onLoad: PropTypes.func,
  onSave: PropTypes.func,
  onAdd: PropTypes.func,
  comments: PropTypes.string,
  onCommentsChange: PropTypes.func,
};

export default ScenarioSelector;
